module.exports = __webpack_public_path__ + "static/img/SF124WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF124WP_1.png
// module id = HAib
// module chunks = 0